import { Divider, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { RatingsExplanationCard } from "@src/appV2/redesign/Tiers/RatingsSection/RatingsExplanationCard";
import { RatingsRequirementsCard } from "@src/appV2/redesign/Tiers/RatingsSection/RatingsRequirementsCard";
import { RatingsTitleCard } from "@src/appV2/redesign/Tiers/RatingsSection/RatingsTitleCard";
import { type NormalizedTierRatings } from "@src/appV2/redesign/Tiers/utils/types";

interface RatingsSectionProps {
  normalizedTierRatings: NormalizedTierRatings;
  lateCancelThresholdInHours: number;
  workerTimeZone: string;
  workerId: string;
}

export function RatingsSection(props: RatingsSectionProps) {
  const { normalizedTierRatings, lateCancelThresholdInHours, workerTimeZone, workerId } = props;
  const { workerTier, goldTierRatings, silverTierRatings } = normalizedTierRatings;

  return (
    <Stack direction="column" gap={8}>
      <RatingsExplanationCard
        normalizedTierRatings={normalizedTierRatings}
        lateCancelThresholdInHours={lateCancelThresholdInHours}
        workerTimeZone={workerTimeZone}
        workerId={workerId}
      />
      <Divider />
      <Stack direction="column" gap={6}>
        <Text semibold variant="h4">
          Ratings needed for each level
        </Text>
        <Stack gap={2}>
          <RatingsTitleCard />
          <RatingsRequirementsCard
            key="GOLD"
            matchesWorkerTier={workerTier === "GOLD"}
            tierType="GOLD"
            normalizedRatings={goldTierRatings}
          />
          <RatingsRequirementsCard
            key="SILVER"
            matchesWorkerTier={workerTier === "SILVER"}
            tierType="SILVER"
            normalizedRatings={silverTierRatings}
          />
          <RatingsRequirementsCard
            key="LIMITED"
            matchesWorkerTier={workerTier === "LIMITED"}
            tierType="LIMITED"
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
